import { type ReactNode } from 'react'
import cx from 'classnames'
import { FormGroup } from '@theneatcompany/nui'

interface FieldErrorProps {
  label?: ReactNode
  message?: ReactNode
  touched?: boolean
  ignoreTouched?: boolean
  onRender?: (label: ReactNode, message: ReactNode) => ReactNode
  className?: string
  alwaysPresent?: boolean
}

const FieldError = ({
  label,
  message,
  touched = false,
  ignoreTouched = false,
  onRender,
  className,
  alwaysPresent = false,
  ...rest
}: FieldErrorProps) => {
  if (!message && !alwaysPresent) return null
  const defaultMessage = label ? `${label} ${message}` : message
  const errorMessage = onRender ? onRender(label, message) : defaultMessage

  let content = message ? errorMessage : ''
  if (alwaysPresent && !content) {
    content = 'placeholder'
  }

  const shouldErrorBeVisible = !!message && (touched || ignoreTouched)

  return (
    (touched || ignoreTouched || alwaysPresent) && (
      <FormGroup.HelperText className={cx(className, !shouldErrorBeVisible && 'hidden')} role="alert" {...rest}>
        {content}
      </FormGroup.HelperText>
    )
  )
}

export default FieldError
